import React from "react";
import logoBlack from "../../images/logo-elumini.png"
import logoYellow from "../../images/logo-elumini-yellow.png"
import "./index.css";
import { Link } from "react-router-dom";

 
class LogoElumini extends React.Component {
render() {
  return (
    <Link to="/" className="elumini-wrappe">
      <img
        src={logoBlack}
        alt="Elumini Logo"
        className="logo-elumini logo-black"
      />
      <img
        src={logoYellow}
        alt="Elumini Logo"
        className="logo-elumini logo-yellow"
      />
    </Link>
        );
    }
}

export default LogoElumini;